module.exports = __webpack_public_path__ + "static/media/guiaAmar.683ee48d.png";